// src/pages/ContentDetail/components/DetailHeader.js
import React from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Print as PrintIcon,
  MoreVert as MoreIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const Header = ({ title, onBack, onPrint, onMenuOpen }) => {
  const theme = useTheme();
  
  return (
    <Box sx={{ mb: 4, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
      <IconButton
        onClick={onBack}
        sx={{ mr: 1, color: theme.palette.text.primary }}
        aria-label="back to dashboard"
      >
        <ArrowBackIcon />
      </IconButton>

      <Typography variant="h4" component="h1" color="primary" fontWeight="bold" sx={{ flexGrow: 1 }}>
        {title}
      </Typography>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<PrintIcon />}
          onClick={onPrint}
        >
          Print
        </Button>

        <IconButton onClick={onMenuOpen} sx={{ color: theme.palette.primary.main }}>
          <MoreIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Header;